import {DynamicPickerAnchor} from '@github-ui/filter-picker'

import {DynamicReposPickerDialog} from './DynamicReposPickerDialog'
import {getReposItemConfig} from './ItemConfig'
import type {DynamicReposProps, PickerRepository} from './types'

export function DynamicReposPicker<TItem extends PickerRepository>(props: DynamicReposProps<TItem>) {
  const {isOpenInitially, ['aria-describedby']: ariaDescribedby, ...dialogProps} = props
  const itemConfig = getReposItemConfig(props.scope)

  return (
    <DynamicPickerAnchor
      isOpenInitially={isOpenInitially}
      query={dialogProps.query}
      itemConfig={itemConfig}
      aria-describedby={ariaDescribedby}
      renderDialog={publicProps => <DynamicReposPickerDialog {...publicProps} {...dialogProps} />}
    />
  )
}

try{ DynamicReposPicker.displayName ||= 'DynamicReposPicker' } catch {}